import axiosInstance from "../../../axios/axiosInstance";
import { useShowAlert } from "../../../hooks/useShowAlert";
import useSendTokenToContact from "./SendToken";
import { useState } from "react";
import { normalizePhoneNumber } from "../../../helper/normalizePhoneNumber";

export const useSignupSubmit = (onSuccess) => {
    const [loading, setLoading] = useState(false);
    const [pendingPhoneNumber, setPendingPhoneNumber] = useState(null);
    const { showAlert } = useShowAlert();
    const { sendTokenToEmail, sendTokenToPhoneNumber } = useSendTokenToContact();

    const signupSubmit = (values) => {
        setLoading(true);
        const isEmail = values.identifier.includes("@") || values.identifier.includes(".");
        const phoneNumber = normalizePhoneNumber(values.countryCode, values.identifier);
        const payload = {
            firstName: values.firstName?.trim(),
            lastName: values.lastName?.trim(),
            password: values.password,
            username: values.username?.trim(),
            [isEmail ? "email" : "phoneNumber"]: isEmail ? values.identifier : phoneNumber
        };

        axiosInstance
            .post("/user/signup", payload)
            .then(() => {
                if (isEmail) {
                    onSuccess?.();
                    sendTokenToEmail(values.identifier);
                } else {
                    setPendingPhoneNumber(phoneNumber);
                }
            })
            .catch((err) => {
                if (err) {
                    showAlert("error", err.response.data.error);
                }
            }).finally(() => {
                setLoading(false);
            });
    };

    const chooseChannel = (channel) => {
        if (!pendingPhoneNumber) return;
        const phoneNumber = pendingPhoneNumber;
        setPendingPhoneNumber(null);
        onSuccess?.();
        sendTokenToPhoneNumber(phoneNumber, channel);
    };

    const cancelChannelPicker = () => setPendingPhoneNumber(null);

    return { signupSubmit, loading, pendingPhoneNumber, chooseChannel, cancelChannelPicker };
};
